export const FEDERAL_MINIMUM_WAGE = 7.25;

export const stateMinimumWages = {
  AK: 11.91,
  AR: 11.0,
  AZ: 14.7,
  CA: 16.5,
  CO: 14.81,
  CT: 16.35,
  DC: 17.5,
  DE: 15.0,
  FL: 13.0,
  HI: 14.0,
  IL: 15.0,
  MA: 15.0,
  MD: 15.0,
  ME: 14.65,
  MI: 10.56,
  MN: 11.13,
  MO: 13.75,
  MT: 10.55,
  NE: 13.5,
  NJ: 15.49,
  NM: 12.0,
  NV: 12.0,
  NY: 16.5,
  OH: 10.7,
  OR: 15.95,
  PR: 10.5,
  RI: 15.0,
  SD: 11.5,
  VA: 12.41,
  VT: 14.01,
  WA: 16.66,
  WV: 8.75,
  VI: 10.5,
  GU: 9.25,
  AL: FEDERAL_MINIMUM_WAGE,
  GA: FEDERAL_MINIMUM_WAGE,
  IA: FEDERAL_MINIMUM_WAGE,
  ID: FEDERAL_MINIMUM_WAGE,
  IN: FEDERAL_MINIMUM_WAGE,
  KS: FEDERAL_MINIMUM_WAGE,
  KY: FEDERAL_MINIMUM_WAGE,
  LA: FEDERAL_MINIMUM_WAGE,
  MS: FEDERAL_MINIMUM_WAGE,
  NC: FEDERAL_MINIMUM_WAGE,
  ND: FEDERAL_MINIMUM_WAGE,
  NH: FEDERAL_MINIMUM_WAGE,
  OK: FEDERAL_MINIMUM_WAGE,
  PA: FEDERAL_MINIMUM_WAGE,
  SC: FEDERAL_MINIMUM_WAGE,
  TN: FEDERAL_MINIMUM_WAGE,
  TX: FEDERAL_MINIMUM_WAGE,
  UT: FEDERAL_MINIMUM_WAGE,
  WI: FEDERAL_MINIMUM_WAGE,
  WY: FEDERAL_MINIMUM_WAGE,
  CNMI: FEDERAL_MINIMUM_WAGE,
  AS: FEDERAL_MINIMUM_WAGE,
};

export const getSuggestedTokenAmount = (stateCode = "", durationMinutes = 0) => {
  const hourlyRate = stateMinimumWages[String(stateCode || "").toUpperCase()] ?? FEDERAL_MINIMUM_WAGE;
  return parseFloat(((hourlyRate / 60) * Number(durationMinutes || 0)).toFixed(2));
};
